import { Controller } from 'react-hook-form';
import { InputSwitch } from 'primereact/inputswitch';
import SelectCards from '../components/Select-cards';
import TemplateBodyField from '../components/template-body-field';
import styles from '../stylesheets/authentication.module.css';

const ctaOptions = [
  { label: 'Copy Code', value: 'COPY_CODE' },
  // { label: 'Autofill', value: 'AUTOFILL' },
  { label: 'No Button', value: 'NONE' },
];

const AuthenticationTemplates = ({
  ccontrol,
  control,
  watch,
  setValue,

  textAreaRef,
  getFormErrorMessage,

  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,

  messsageVariables,
  menuRef,

  showEmoji,
  setShowEmoji,
  handleEmojiClick,

  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,
}) => {
  //   const watchMessageType = watch("messageType");
  const watchAuthCTA = watch('authCTA');

  const getCTALabel = () => {
    switch (watchAuthCTA) {
      case 'COPY_CODE':
        return 'Copy Code';
      // case 'AUTOFILL':
      //   return 'Autofill';
      case 'NONE':
        return '';
      default:
        return;
    }
  };

  return (
    <div className="w-full flex flex-column">
      <div className="mt-4">
        <label className="form-label">Optional</label>

        {/* Security Disclaimer */}

        <Controller
          name="securityDisclaimer"
          control={control}
          defaultValue={true}
          render={({ field }) => (
            <div className={styles.optionCard}>
              <InputSwitch checked={field.value} onChange={(e) => field.onChange(e.value)} />
              <div>
                <div className={styles.optionTitle}>Security disclaimer</div>
                <div className={styles.optionDesc}>For your security, do not share this code</div>
              </div>
            </div>
          )}
        />

        {/* Expiration Warning */}

        <Controller
          name="expirationWarning"
          control={control}
          defaultValue={true}
          render={({ field }) => (
            <div className={styles.optionCard}>
              <InputSwitch checked={field.value} onChange={(e) => field.onChange(e.value)} />
              <div>
                <div className={styles.optionTitle}>Expiration warning</div>
                <div className={styles.optionDesc}>
                  This code expires in {'<NUM_MINUTES>'} minutes
                </div>
              </div>
            </div>
          )}
        />
      </div>

      {/* CTA */}

      <div className="mt-4">
        <label className="form-label">CTA</label>

        <SelectCards
          control={control}
          name="authCTA"
          options={ctaOptions}
          defaultValue="COPY_CODE"
        />
      </div>

      {/* {watchAuthCTA !== 'NONE' && ( */}
      <div>
        <div className={styles.ctaPreviewBox}>
          <div className={styles.CTAHeader}>
            <p className={styles.CTAHeadeLabel}>CTA preview</p>
          </div>

          <div className={styles.chatBubbleContainer}>
            <div className={styles.ctaButtonContainer}>
              <div className={styles.ctaButton}>{getCTALabel()}</div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export default AuthenticationTemplates;
